import { Node } from '../graphql/types';

type EdgeWithoutCursor<T> = { node: T };

export const nodesToEdges = <T extends Node>(
  nodes: T[],
): { edges: EdgeWithoutCursor<T>[] } => ({
  edges: nodes.map((node) => ({
    node,
  })),
});

export const edgesToNodes = <T>(edges?: EdgeWithoutCursor<T>[]): T[] =>
  edges?.map(({ node }) => node) || [];
